import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-base text-background-950"></i>
                </span>
                <span className="text-lg font-heading font-bold text-foreground-50">
                  被窝影院
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                被窝影院官网提供高清电影电视剧免费在线观看，最新热门影片每日更新，支持手机APP下载，随时随地畅享高清观影体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-label font-semibold text-foreground-200 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <FooterLink to="/" label="首页" />
                <FooterLink to="/category/movie" label="电影" />
                <FooterLink to="/category/tv" label="电视剧" />
                <FooterLink to="/category/anime" label="动漫" />
                <FooterLink to="/category/variety" label="综艺" />
              </div>
            </div>

            <div>
              <h4 className="text-sm font-label font-semibold text-foreground-200 mb-4">热门推荐</h4>
              <div className="flex flex-col gap-2">
                <FooterLink to="/detail/hot-1" label="哪吒之魔童闹海" />
                <FooterLink to="/detail/tv-2" label="庆余年2" />
                <FooterLink to="/detail/hero-1" label="流浪地球3" />
                <FooterLink to="/detail/tv-4" label="狂飙" />
                <FooterLink to="/detail/anime-2" label="葬送的芙莉莲" />
              </div>
            </div>

            <div>
              <h4 className="text-sm font-label font-semibold text-foreground-200 mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <FooterLink to="/about" label="品牌介绍" />
                <FooterLink to="/about" label="口碑评价" />
                <FooterLink to="/about" label="联系方式" />
                <FooterLink to="/about" label="APP下载" />
              </div>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/20 text-foreground-400 hover:text-primary-400 transition-all cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/20 text-foreground-400 hover:text-primary-400 transition-all cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/20 text-foreground-400 hover:text-primary-400 transition-all cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between mt-10 pt-6 border-t border-background-800/50 gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2024-2026 被窝影院 beiwoyingyuan.com 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-foreground-300 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-foreground-300 transition-colors">服务条款</a>
              <a href="#" className="hover:text-foreground-300 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
    >
      {label}
    </Link>
  );
}